import React, { useCallback } from 'react'
import Tooltip from 'components/Luxkit/Tooltip'
import moment from 'moment'
import { INTL_DMY_CASUAL_FORMAT } from 'constants/dateFormats'
import { intlFormatter } from 'lib/datetime/dateUtils'

interface Props extends React.PropsWithChildren {
  dates?: {
    bookBy: moment.Moment,
    travelUntil: moment.Moment,
  }
  customText?: string;
  onOpen?: () => void;
}

function GiftTooltip(props: Props) {
  const { children, dates, customText, onOpen } = props

  let msg = ''
  if (customText) {
    msg = customText
  } else if (dates) {
    msg = `Buy a package and send as a gift to a special someone. They can book by ${intlFormatter(dates.bookBy.toDate(), INTL_DMY_CASUAL_FORMAT)} and travel until ${intlFormatter(dates.travelUntil.toDate(), INTL_DMY_CASUAL_FORMAT)}.`
  }

  const handleTooltipChange = useCallback((open: boolean) => {
    if (open) {
      onOpen?.()
    }
  }, [onOpen])

  return <Tooltip
    description={msg}
    placement="top"
    onOpenChange={handleTooltipChange}
  >
    {children}
  </Tooltip>
}

export default GiftTooltip
